import {
    RecommendationsAction,
    UPDATE_RECOMMENDATION_CARD_STATUS,
    UPDATE_RECOMMENDATIONS
} from '../actions/recommendations';
import { recommendationsInitialState } from '../service/RecommendationsHelpers/RecommendationsHelpers';
import { GdRecommendationStatus } from '../typings/graphql-grid';
import { RecommendationType, SummaryRecommendation } from '../typings/recommendations';
import { RecommendationsState, State } from '../typings/state';

function setRecommendationStatus(
    recommendationItem: SummaryRecommendation,
    status: GdRecommendationStatus,
    type: RecommendationType
): SummaryRecommendation {
    if (recommendationItem.type === type) {
        return {
            ...recommendationItem,
            status
        };
    }

    return recommendationItem;
}

export function recommendations(
    state: RecommendationsState = recommendationsInitialState,
    action: RecommendationsAction,
    fullState: State
): RecommendationsState {
    switch (action.type) {
        case UPDATE_RECOMMENDATIONS:
            return {
                ...state,
                recommendationsData: action.recommendations,
                recommendationsReqId: action.recommendationsReqId
            };

        case UPDATE_RECOMMENDATION_CARD_STATUS:
            return {
                ...state,
                recommendationsData: state.recommendationsData
                    ? state.recommendationsData.map(recommendationItem =>
                          setRecommendationStatus(recommendationItem, action.status, action.recommendationType)
                      )
                    : undefined
            };

        default:
            return state;
    }
}
